import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	transferListContainer: {},
	transferReceiveHeaderRoot: {
		"& .MuiAccordionDetails-root": {
			[theme.breakpoints.down("sm")]: {
				paddingLeft: theme.spacing(1.5),
				paddingRight: theme.spacing(1.5),
			},
			paddingBottom: theme.spacing(0.5),
		},
	},
	sourceId: {
		paddingLeft: theme.spacing(1),
	},
	transferCard: {
		cursor: "pointer",
		margin: theme.spacing(1, 0),
	},
	transferItemCol1: {
		paddingRight: theme.spacing(2),
	},
	transferItemCol2: {
		whiteSpace: "normal",
		wordBreak: "break-word",
	},
	transferReceiveHeader: {
		height: "45px",
		minHeight: "45px !important",
		[theme.breakpoints.down("sm")]: {
			minHeight: "40px",
			height: "55px",
		},
		"&.MuiAccordionSummary-root.Mui-expanded": {
			[theme.breakpoints.down("sm")]: {
				minHeight: "40px",
				paddingTop: "12px !important",
				height: "45px !important",
			},
		},
		"& .MuiIconButton-root": {
			[theme.breakpoints.down("sm")]: {
				paddingRight: theme.spacing(0.4),
				paddingLeft: theme.spacing(0.4),
			},
		},
		"&.MuiAccordionSummary-root": {
			[theme.breakpoints.down("sm")]: {
				paddingLeft: theme.spacing(1.5),
				paddingRight: theme.spacing(1.5),
			},
		},
	},
	transferNumberContainer: {
		gap: theme.spacing(0),
		width: "calc(7.75 / 12 * 100%)",
		maxWidth: "calc(7.75 / 12 * 100%)",
		flexBasis: "calc(7.75 / 12 * 100%)",
		[theme.breakpoints.up("sm")]: {
			gap: theme.spacing(1),
			width: "calc(6 / 12 * 100%)",
			maxWidth: "calc(6 / 12 * 100%)",
			flexBasis: "calc(6 / 12 * 100%)",
		},
	},
	receiveFailureReasonGrid: {
		marginTop: "8px",
	},
}));
